import { isSSR } from '@sketch-note/design-system/src/shared/utils';

import { CLOSE_SIDEBAR, OPEN_SIDEBAR, TOGGLE_SIDEBAR } from '../types';

const isMobile = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const layoutInitialState = {
  isSidebarOpened: !isSSR() && isMobile() ? false : true,
};

export default function layoutReducer(state = layoutInitialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarOpened: !state.isSidebarOpened,
      };
    case CLOSE_SIDEBAR:
      return {
        ...state,
        isSidebarOpened: false,
      };
    case OPEN_SIDEBAR:
      return {
        ...state,
        isSidebarOpened: true,
      };

    default:
      return state;
  }
}
